import moment from "moment";

export function formatForDisplay(date) {
    return moment(date).format("MMM DD h:mm a");
}

export function formatForDisplayDate(date) {
  return moment(date).format("MMM Do YYYY");
}